import { getSessionData } from '../auth';
import { getUserLanguageFromAvailableLanguages } from '../localization/language-resolving';
import { APP_SHELL_IDENTIFIER, type AppConfig, type DataLayerBase } from '../types';

const UNSET_COUNTRY = 'UNSET';

export function createDataLayerBase(config: AppConfig): DataLayerBase {
  return {
    pageArea: 'web',
    pageCountry: getSessionData()?.country || UNSET_COUNTRY,
    pageEnvironment: config.tracking.environment,
    pageIdentifier: APP_SHELL_IDENTIFIER,
    pageLanguage: getUserLanguageFromAvailableLanguages(config.availableLanguages),
    pageName: 'Home',
    pagePool: 'med',
    contentHierarchy1: APP_SHELL_IDENTIFIER,
  };
}
